module.exports = __webpack_public_path__ + "static/media/text-italic.93993357.svg";